// Catalog.ID Client — Print-Gate Onboarding Completion
// ============================================================================
// The ordering rule behind the type-back print gate (registration-restructure
// §3.2 step 6 / §8.5): tell the server the account's onboarding is COMPLETE
// first, wipe the local onboarding stash second.
//
// Why the order matters. An account that never receives its completion call is
// purged by the server after 7 days ('terminated', reason
// 'onboarding_incomplete'). The stash is the only way back into the wizard —
// it carries the throwaway credentials, the reserved CID and the Account Unlock Sheet
// token. Wiping it before the server confirms would leave a member holding a
// printed booklet for an account that quietly dies a week later, with no
// resume path. So: on failure the stash stays, the gate shows a retryable
// error, and a resume lands on the gate again.
//
// Kept separate from the wizards (which are DOM-only, covered by tsc + build)
// so the ordering itself is unit-testable.

/**
 * Run `completions` in order; call `wipe` only if every one of them resolved.
 * Rethrows the first failure without wiping, and is safe to re-run — the
 * server endpoints are idempotent, which is what makes the gate's Retry button
 * a repeat of the calls rather than a repeat of the whole gate.
 */
export async function completeOnboardingThenWipe(
    completions: ReadonlyArray<() => Promise<void>>,
    wipe: () => void,
): Promise<void> {
    for (const complete of completions) {
        await complete();
    }
    wipe();
}
